export default "__VITE_ASSET__B1YZvN7Q__"